<template>
    <div class="template-base">
        <InputCredentials ref="refInputCredentials" v-show="showInputCredentials" @on-cancel="showInputCredentials = false" />
        <Header Title="Merchant of Record Dashboard" :iconPath="'/images/icons/merchant-of-record.png'" class="div-header"></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit" :disabled="fetchingData"></Button>            
            <div style="display:flex;">
                <RangeSelector @on-view="onView" style="background-color: transparent; border: 0px;margin: auto;" :hideCancel="true" v-if="!fetchingData"/>
            </div>                    
        </div>
        

        
        <div style="display: flex; flex-direction: row; justify-content: space-between;width:100%;height: 20px;padding: 5px;" v-if="dataReport.length !== 0">            
            <img src="/images/icons/copy.png" class="button-link image-pad" @click="copyInfo" style="width:20px;margin-left:10px"  />
            <div style="display: flex; flex-direction: column;">
                <button class="button-link" style="margin-right:10px;font-size: 11pt;height:25px;width:250px;" @click="calculateCardPointeTotals" :disabled="fetchingData">
                    Validate totals with CardPointe
                </button>
                <div style="display: flex;justify-content:flex-end;margin-right: 35px;font-size: 11pt;gap:5px">
                    <input type="checkbox" id="chkShowCardPointeWindow" v-model="showCardPointeWindow" :disabled="fetchingData"/>
                    <label for="chkShowCardPointeWindow">UI</label>
                </div>
            </div>
        </div>

        <div style="display: flex; flex-direction: row; align-items: start;height: 80%;margin-top: 40px;padding: 10px;">
            
            <table class="report-div-table" cellspacing="0">
                <tr class="report-div-table-row" v-if="dataReport.length !== 0">
                    <th class="report-div-table-col" style="width: 20%">Site</th>
                    <th class="report-div-table-col" style="width: 20%;text-align: right;">Total Net Income (CC)</th>                    
                    <th class="report-div-table-col" style="width: 20%;text-align: right">Total Income (CC)</th>
                    <th class="report-div-table-col" style="width: 20%;text-align: right">CardPointe Total Income</th>                    
                    <th class="report-div-table-col" style="width: 20%;text-align: right">Difference</th>                    
                </tr>

                <tr v-for="row in dataReport" :key="row.description" class="report-div-table-row">                                                        
                    <td class="report-div-table-col" style="text-align:left">{{ row.siteName }}</td>
                    <td class="report-div-table-col" style="text-align:right;"><span style="color: darkgreen;font-weight: bold;">{{ Utilities.toCurrency(row.totalNetIncome) }}</span></td>
                    <td class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(row.totalIncome) }}</td>

                    <td v-if="row.totalIncomeCardPointe !== null" class="report-div-table-col" style="text-align:right">{{ Utilities.toCurrency(row.totalIncomeCardPointe) }}</td>
                    <td v-if="row.totalIncomeCardPointe !== null" class="report-div-table-col" style="text-align:right"><span :style="(row.totalIncomeCardPointe - row.totalIncome != 0) ? 'color:white;background-color: red;font-weight: bold;' : ''"> {{ Utilities.toCurrency(row.totalIncomeCardPointe - row.totalIncome) }}</span></td>

                    <td v-if="row.totalIncomeCardPointe === null" class="report-div-table-col" style="text-align:right">-</td>
                    <td v-if="row.totalIncomeCardPointe === null" class="report-div-table-col" style="text-align:right">-</td>
                </tr>
                
                <tr v-if="dataReport.length > 0" class="report-div-table-row">                                                        
                    <td class="report-div-table-col" style="text-align:left;font-weight: bold;">TOTAL</td>
                    <td class="report-div-table-col" style="text-align:right;font-weight: bold">{{ Utilities.toCurrency(grandTotalNetIncome) }}</td>
                    <td class="report-div-table-col" style="text-align:right;font-weight: bold">{{ Utilities.toCurrency(grandTotalIncome) }}</td>

                    <td colspan="4"></td>                    
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import { ref } from "vue";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import { storage } from "@/common/storage";
import RangeSelector from "@/views/components/Reports/RangeSelector.vue";
import Utilities from "@/common/utilities";
import apiReport from "@/api/apiReport";
import apiCardPointe from "@/api/apiCardPointe";
import CardPointeCompare from "@/common/CardPointeCompare";
import InputCredentials from "@/views/components/Shared/InputCredentials";

export default {
    components: { Header, Button, RangeSelector, InputCredentials },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);        
        const dataReport = ref([]);
        const showCardPointeWindow = ref(false);
        const refInputCredentials = ref(null);
        const showInputCredentials = ref(false);
        const grandTotalNetIncome = ref(0);
        const grandTotalIncome = ref(0);

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnValidate = ButtonModel.CreateClick("");
        btnValidate.iconPath = "/images/icons/validate.png";
        btnValidate.title = "Validate with processor...";

        onMounted(() => {
            console.log("mounted");
        });

        onBeforeRouteLeave( async (/*to, from*/) => {
            await apiCardPointe.close()
            return true;
        });

        // window.onbeforeunload = async () => {
        //     alert("dddd")
        //     //await apiCardPointe.close()
        //     return true;
        // };

        const onView = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;
                dataReport.value = []
                dataReport.value = await apiReport.getMoRStatus(storage.getReportDateStart(), storage.getReportDateEnd()); 

               grandTotalNetIncome.value =   dataReport.value.reduce((sum, item) => sum + item.totalNetIncome, 0);
               grandTotalIncome.value =   dataReport.value.reduce((sum, item) => sum + item.totalIncome, 0);
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            } finally {
                emitter.emit("server-call-stop");
                fetchingData.value = false;
            }            
        };

        const getCardPointeCredentials = async () => {
            refInputCredentials.value.initWindow(
                "Enter CardPointe Credentials",
                async (username, password) => {
                    showInputCredentials.value = false
                    let proceed = true

                    if ((username !== null) && (username.length > 0)) {
                        storage.setCardPointeUsername(username)
                    } else {
                        proceed = false
                    }

                    if ((password !== null) && (password.length > 0)) {
                        storage.setCardPointePassword(password)
                    } else {
                        proceed = false
                    }

                    if (proceed)
                        await calculateCardPointeTotals()
            });
            showInputCredentials.value = true
        }

        const calculateCardPointeTotals = async () => {
            try {
                emitter.emit("server-call-start", "Getting data from CardPointe...");
                fetchingData.value = true;                
                
                dataReport.value.forEach(element => {
                    element.totalIncomeCardPointe = null;
                });
                

                if (storage.getCardPointeUsername() === '') {
                    await getCardPointeCredentials()
                    return
                }

                if (storage.getCardPointePassword() === '') {
                    await getCardPointeCredentials()
                    return
                }
                
                let initResponse = await apiCardPointe.init(storage.getCardPointeUsername(), storage.getCardPointePassword(), !showCardPointeWindow.value)
                if (initResponse.requireSecurityCode) {
                    let value = prompt("CardPointe Security Code")
                    if (value === null)
                        return;

                    await apiCardPointe.securityCode(value)
                }

                for (let i = 0; i < dataReport.value.length; i++) {            
                    const element = dataReport.value[i]                    
                    let cardPointeData = await apiCardPointe.getDataByMid(element.merchantId, storage.getReportDateStart(), storage.getReportDateEnd())                
                    const cardPointeCompare = new CardPointeCompare();
                    element.totalIncomeCardPointe = cardPointeCompare.getTotal(cardPointeData.csvData);
                }

                await apiCardPointe.close()

            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error getting data from CardPointe", err]);
                storage.setCardPointeUsername("")
                storage.setCardPointePassword("")
            } finally {
                emitter.emit("server-call-stop");
                fetchingData.value = false;
            }            
        };

        const copyInfo =  () => {
            
            let [y, m, d] = storage.getReportDateStart().split(' ')[0].split("-").map(Number)
            const start = (new Date(y, m - 1, d)).toLocaleDateString("en-US", { month: "short", day: "numeric" });

            [y, m, d] = storage.getReportDateEnd().split(' ')[0].split("-").map(Number)
            const end = (new Date(y, m - 1, d)).toLocaleDateString("en-US", { month: "short", day: "numeric" });
            
            
            let info = `Send MoR Sites (${start} - ${end})\n\n`
            dataReport.value.forEach(element => {
                info += `${element.siteName.padEnd(40," ")} ${Utilities.toCurrency(element.totalNetIncome).padStart(12," ")}\n`
            })
            info += `\n${"TOTAL".padEnd(40," ")} ${Utilities.toCurrency(grandTotalNetIncome.value).padStart(12," ")}\n`
            var dummy = document.createElement("textarea");
            document.body.appendChild(dummy);
            dummy.value = info;
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);
        }

        return {
            btnExit,
            fetchingData,
            onView,
            Utilities,
            btnValidate,
            dataReport,
            calculateCardPointeTotals,
            showCardPointeWindow,
            copyInfo,
            refInputCredentials,
            showInputCredentials,
            grandTotalNetIncome,
            grandTotalIncome
        };
    }
};
</script>

<style scoped>
.mor-dash-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
    height: 100%;
    padding: 20px;
}

.mor-dash-site-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    /* background-color: red; */
}

.mor-dash-button {
    color: var(--button-color);
    padding: 4px;
    margin-right: 10px;
    width: 70px;
    cursor: pointer;
    text-align: center;
    border: 1px solid black;
}

.mor-dash-checkbox-list {
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 4px;
    background: #fff;
    width: 100%;
    height: 90%;
}

.mor-dash-checkbox-row {
    cursor: pointer;
    padding: 4px;
    user-select: none;
}
.mor-dash-checkbox-row:hover {
    background-color: #f3f3f3;
}

.mor-dash-progress-container {
    width: 100%;
    background-color: #eee;
    /* border-radius: 10px; */
    overflow: hidden;
    height: 30px;
    /* margin-bottom: 10px; */
}

.mor-dash-progress-bar {
    height: 100%;
    width: 0%;
    background-color: var(--job-runner-color);
    transition: width 0.3s ease;
}

.mor-dash-input-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    /* margin: 10px 0px; */
    padding: 0px 10px;
}
.mor-dash-input-item-select {
    width: 161px;
    height: 30px;
}
.mor-dash-listing {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

.mor-dash-section-group {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 20px;
}

.mor-dash-section {
    margin-top: 10px;
}

.mor-dash-button-link {
    font-size: 11pt;
}

.mor-dash-section-title {
    margin-top: 20px;
    font-size: 13pt;
    color: black;
}
</style>
